// @flow
export const ITEM_DETAIL_MODAL = 'modal.itemDetail';
export const OPEN_ITEM_DETAIL_MODAL = 'OPEN_ITEM_DETAIL_MODAL';
export const CLOSE_ITEM_DETAIL_MODAL = 'CLOSE_ITEM_DETAIL_MODAL';

export const ITEM_DETAIL_MODAL_TYPE = {
  INSTRUCTIONS: 'instructions',
  QR: 'qr',
  BID_HISTORY: 'bidHistory',
  ABOUT_SHIPPING: 'aboutShipping',
  QUESTIONS: 'itemQuestions',
  HOW_TO_BID: 'howToBid'
};

export const FETCH_ITEM_RESOURCE = 'fetch_item_';
export const FETCH_ITEM_REQUEST = 'FETCH_ITEM_REQUEST';
export const FETCH_ITEM_SUCCESS = 'FETCH_ITEM_SUCCESS';
export const FETCH_ITEM_FAILED = 'FETCH_ITEM_FAILED';

export const FETCH_ITEM_BIDS_RESOURCE = 'fetch_item_bids_';
export const FETCH_ITEM_BIDS_REQUEST = 'FETCH_ITEM_BIDS_REQUEST';
export const FETCH_ITEM_BIDS_SUCCESS = 'FETCH_ITEM_BIDS_SUCCESS';
export const FETCH_ITEM_BIDS_FAILED = 'FETCH_ITEM_BIDS_FAILED';



// WEBPACK FOOTER //
// ./src/services/item/constants.js